import React, {Fragment, useEffect} from "react"
import {useDispatch} from "react-redux"

// UI
import {Container} from "@uprise/grid"
import {Alert} from "@uprise/alert"
// Slices
import {
	clearDisableUserState,
	clearToggleDashUserState,
	clearupdateUserApiState,
	clearUpdateSessionApiState,
	clearRequestAdditionalSessions,
	clearUserNotesApiState
} from "features/Users/usersSlice"
import {clearBookingApiState} from "features/Bookings/bookingSlice"

export const Alerts = ({
	userDetailsState,
	userBookingsApiState,
	userNotificationState,
	userDisableUserApiState,
	toggleDashboardApiState,
	userNotesApiState,
	updateUserApiState,
	cancelBookingApiState,
	clearCancelBookingApiState,
	createBookingApiState,
	updatedSessionApiState,
	requestSessionsApiState
}) => {
	const dispatch = useDispatch()

	useEffect(() => {
		if (userDisableUserApiState.isSuccess || userDisableUserApiState.isError) {
			setTimeout(() => {
				dispatch(clearDisableUserState())
			}, 3000)
		}
		if (toggleDashboardApiState.isError || toggleDashboardApiState.isSuccess) {
			setTimeout(() => {
				dispatch(clearToggleDashUserState())
			}, 3000)
		}
		if (cancelBookingApiState.isError || cancelBookingApiState.isSuccess) {
			setTimeout(() => {
				dispatch(clearCancelBookingApiState())
			}, 3000)
		}

		if (updateUserApiState.isError || updateUserApiState.isSuccess) {
			setTimeout(() => {
				dispatch(clearupdateUserApiState())
			}, 3000)
		}
		if (createBookingApiState.isSuccess || createBookingApiState.isError) {
			setTimeout(() => {
				dispatch(clearBookingApiState())
			}, 8000)
		}
		if (updatedSessionApiState.isSuccess || updatedSessionApiState.isError) {
			setTimeout(() => {
				dispatch(clearUpdateSessionApiState())
			}, 3000)
		}
		if (requestSessionsApiState.isSuccess || requestSessionsApiState.isError) {
			setTimeout(() => {
				dispatch(clearRequestAdditionalSessions())
			}, 3000)
		}
		if (userNotesApiState.isSuccess || userNotesApiState.isError) {
			setTimeout(() => {
				dispatch(clearUserNotesApiState())
			}, 3000)
		}
	}, [
		toggleDashboardApiState,
		userDisableUserApiState,
		cancelBookingApiState,
		updateUserApiState,
		createBookingApiState,
		updatedSessionApiState,
		requestSessionsApiState,
		userNotesApiState
	])

	return (
		<Container className='m-b-6'>
			{!userDetailsState.isError && (
				<Fragment>
					{toggleDashboardApiState.isError && <Alert type='error'>{toggleDashboardApiState.message}</Alert>}
					{toggleDashboardApiState.isSuccess && (
						<Alert type='success'>{toggleDashboardApiState.message}</Alert>
					)}
					{userDisableUserApiState.isError && <Alert type='error'>{userDisableUserApiState.message}</Alert>}
					{userDisableUserApiState.isSuccess && (
						<Alert type='success'>{userDisableUserApiState.message}</Alert>
					)}

					{userBookingsApiState.isError && userBookingsApiState.message && (
						<Alert textAlign='center' type='error'>
							{userBookingsApiState.message}
						</Alert>
					)}

					{userNotificationState.isSuccess && userNotificationState.message ? (
						<Alert textAlign='center' type={"success"}>
							{userNotificationState.message}
						</Alert>
					) : userNotificationState.isError && userNotificationState.message ? (
						<Alert textAlign='center' type={"error"}>
							{userNotificationState.message}
						</Alert>
					) : null}

					{updateUserApiState.isSuccess && updateUserApiState.message ? (
						<Alert textAlign='center' type={"success"}>
							{updateUserApiState.message}
						</Alert>
					) : updateUserApiState.isError && updateUserApiState.message ? (
						<Alert textAlign='center' type={"error"}>
							{updateUserApiState.message}
						</Alert>
					) : updateUserApiState.isFetching ? (
						<Alert textAlign='center' type={"success"}>
							User Details are updating. Please wait...
						</Alert>
					) : null}

					{userNotesApiState.isSuccess && userNotesApiState.message ? (
						<Alert textAlign='center' type={"success"}>
							{userNotesApiState.message}
						</Alert>
					) : userNotesApiState.isError && userNotesApiState.message ? (
						<Alert textAlign='center' type={"error"}>
							{userNotesApiState.message}
						</Alert>
					) : null}
				</Fragment>
			)}
			{userDetailsState.isError && (
				<Fragment>
					{userDetailsState.isError && userDetailsState.message && (
						<Alert textAlign='center' type={"error"}>
							{userDetailsState.message}
						</Alert>
					)}
				</Fragment>
			)}
			{cancelBookingApiState.isError && (
				<>
					{cancelBookingApiState.isError && cancelBookingApiState.message && (
						<Alert textAlign='center' type={"error"}>
							{cancelBookingApiState.message}
						</Alert>
					)}
				</>
			)}
			{cancelBookingApiState.isSuccess && (
				<>
					{cancelBookingApiState.isSuccess && cancelBookingApiState.message && (
						<Alert textAlign='center' type={"success"}>
							{cancelBookingApiState.message}
						</Alert>
					)}
				</>
			)}
			{createBookingApiState.isSuccess && (
				<Alert className='m-b-5' type='success'>
					Booking successfully created
				</Alert>
			)}

			{createBookingApiState.isError && (
				<Alert className='m-b-5' type='error'>
					{createBookingApiState.message}
				</Alert>
			)}

			{updatedSessionApiState.isSuccess && (
				<Alert className='m-b-5' type='success'>
					Session details are successfully saved
				</Alert>
			)}

			{updatedSessionApiState.isError && (
				<Alert className='m-b-5' type='error'>
					Error saving Session details
				</Alert>
			)}

			{requestSessionsApiState.isSuccess && (
				<Alert className='m-b-5' type='success'>
					Additional session details are successfully saved
				</Alert>
			)}

			{requestSessionsApiState.isError && (
				<Alert className='m-b-5' type='error'>
					Error saving Session details
				</Alert>
			)}
		</Container>
	)
}
